var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgorithmicIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.545,
    height: 50,
    viewBox: "0 0 54.545 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "display-code",
    d: "M43.182,1H11.364A11.377,11.377,0,0,0,0,12.364V30.545A11.377,11.377,0,0,0,11.364,41.909H25v4.545H15.909a2.273,2.273,0,0,0,0,4.545H38.636a2.273,2.273,0,1,0,0-4.545H29.545V41.909H43.182A11.377,11.377,0,0,0,54.545,30.545V12.364A11.377,11.377,0,0,0,43.182,1ZM16.575,23.061l5.87,5.873a2.272,2.272,0,1,1-3.214,3.214l-5.87-5.873a6.823,6.823,0,0,1,0-9.641l5.87-5.873a2.272,2.272,0,1,1,3.214,3.214l-5.87,5.873a2.274,2.274,0,0,0,0,3.214Zm24.609,3.214-5.87,5.873A2.272,2.272,0,0,1,32.1,28.934l5.87-5.873a2.274,2.274,0,0,0,0-3.214L32.1,13.975a2.272,2.272,0,0,1,3.214-3.214l5.87,5.873a6.823,6.823,0,0,1,0,9.641Z",
    transform: "translate(0 -1)",
    fill: "#3db6fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorithmicIntelligence);
export default __webpack_public_path__ + "static/media/algorithmic_intelligence.fd62186298e437959f7788742b6973c2.svg";
export { ForwardRef as ReactComponent };